/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { InlineNotification, LoadingItem, LoadingSection, Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/enterprise-admin-analytics';

const styles = {
  loadingSection: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: var(--cds-spacing-200);
  `,
};

export enum REPORT_STEPS {
  LOADING = 'LOADING',
  ERROR = 'ERROR',
  TIMEOUT_ERROR = 'TIMEOUT_ERROR',
  SUCCESS = 'SUCCESS',
}

export const LoadingStep = () => {
  return (
    <div css={styles.loadingSection}>
      <LoadingItem label={_t('Processing report...')} />
      <Typography2 component="p" variant="bodySecondary" color="supportText">
        {_t(
          'If you’re short on time, feel free to close this popup — we’ll send you the report via email within an hour.'
        )}
      </Typography2>
    </div>
  );
};

export const ErrorStep = () => {
  return <LoadingSection hasError label={_t('Something went wrong. Please try again later.')} />;
};

export const TimeoutErrorStep = () => {
  return (
    <LoadingSection
      hasError
      label={_t('Processing is taking longer than expected. Please check your email later for more details.')}
    />
  );
};

export const SuccessStep = () => {
  return (
    <InlineNotification severity="information">
      {_t('Your report has been downloaded and sent to your email.')}
    </InlineNotification>
  );
};
